// Travel and Real Estate websites share this admin. A site's vertical comes
// from its template (backend/app/websites/registry.py); a site without one is
// a travel site, as every site was before Real Estate (RE_WEBSITE).

export const REAL_ESTATE = "real_estate";
export const TRAVEL = "travel";

export function siteVertical(site) {
  return site?.vertical || TRAVEL;
}

export function isRealEstateSite(site) {
  return siteVertical(site) === REAL_ESTATE;
}

export function domainExample(vertical) {
  return vertical === REAL_ESTATE ? "www.youragency.com" : "www.yourtravelbrand.com";
}

const VERTICAL_GROUPS = [
  { vertical: TRAVEL, label: "Travel websites", caption: "Trips and packages, with online booking or enquiries." },
  { vertical: REAL_ESTATE, label: "Real estate websites", caption: "Homes for sale and rent from your listings, with inspections and appraisals." },
];

// Templates in labelled groups, travel first, empty groups left out. A tenant
// with one vertical gets one group, and the picker shows it without a heading.
export function templateGroups(templates) {
  return VERTICAL_GROUPS
    .map((group) => ({ ...group, templates: (templates || []).filter((item) => (item.vertical || TRAVEL) === group.vertical) }))
    .filter((group) => group.templates.length);
}

export function templateVertical(templates, templateId) {
  return (templates || []).find((item) => item.id === templateId)?.vertical || TRAVEL;
}

// Locale and currency a new site starts with. Real estate follows the
// tenant's variant (UAE: en-AE / AED, Australia: en-AU / AUD).
export function verticalDefaults(vertical, variantPack) {
  if (vertical === REAL_ESTATE && variantPack) {
    return { default_locale: variantPack.locale || "en-AE", default_currency: variantPack.currency || "AED" };
  }
  return { default_locale: "en-AU", default_currency: "AUD" };
}

// Mirrors PUBLISHABLE_LISTING_STATUSES in backend/app/Routes/websites.py.
export const PUBLISHABLE_LISTING_STATUSES = ["ACTIVE", "UNDER_OFFER", "CLOSED"];

export function canPublishListing(row) {
  return PUBLISHABLE_LISTING_STATUSES.includes(row?.status);
}

export function listingStatusNote(row) {
  if (canPublishListing(row)) return row.status === "CLOSED" ? "Sold or leased: shown only under recently sold" : "";
  return "Only an active, under-offer, sold or leased listing can be published.";
}

const ENTRY_FIELDS = [
  "is_published",
  "is_featured",
  "hide_address",
  "public_slug",
  "title_override",
  "description_override",
  "sort_order",
];

// The PUT replaces every publication field, so a change to one field sends
// the others as they are. Blank text goes as null (the backend then derives
// the slug and uses the listing's own title and description).
export function listingEntryPayload(row, changes = {}) {
  const merged = { ...row, ...changes };
  const payload = {};
  ENTRY_FIELDS.forEach((field) => {
    payload[field] = merged[field];
  });
  payload.is_published = Boolean(payload.is_published);
  payload.is_featured = Boolean(payload.is_featured);
  payload.hide_address = Boolean(payload.hide_address);
  ["public_slug", "title_override", "description_override"].forEach((field) => {
    const value = typeof payload[field] === "string" ? payload[field].trim() : payload[field];
    payload[field] = value || null;
  });
  payload.sort_order = Number.isFinite(Number(payload.sort_order)) ? Math.trunc(Number(payload.sort_order)) : 0;
  return payload;
}

export function publishedCount(entries) {
  return (entries || []).filter((entry) => entry.is_published).length;
}
